import React from 'react';
import { Grid, TextField, InputAdornment, Box } from '@mui/material';
import { User, Mail, Phone, Lock } from 'lucide-react';
import { StepProps } from './TypeCadEscriComponents';
import { telefone } from '../../../components/Inputs/masks';


const PersonalInfoStep: React.FC<StepProps> = ({ formik, activeStep }) => {
    if (activeStep !== 0) return null;

    return (
        <Box sx={{ mt: 2 }}>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                    <TextField
                        fullWidth
                        id="proprietario"
                        name="proprietario"
                        label="Nome Completo"
                        value={formik.values.proprietario}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.proprietario && Boolean(formik.errors.proprietario)}
                        helperText={formik.touched.proprietario && formik.errors.proprietario}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <User size={20} />
                                </InputAdornment>
                            ),
                        }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        id="email_escritorio"
                        name="email_escritorio"
                        label="Email"
                        type="email"
                        value={formik.values.email_escritorio}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.email_escritorio && Boolean(formik.errors.email_escritorio)}
                        helperText={formik.touched.email_escritorio && formik.errors.email_escritorio}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Mail size={20} />
                                </InputAdornment>
                            ),
                        }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        id="telefone_escritorio"
                        name="telefone_escritorio"
                        label="Telefone Whatsapp"
                        value={formik.values.telefone_escritorio}
                        onChange={e => formik.setFieldValue('telefone_escritorio', telefone(e.target.value))}
                        onBlur={formik.handleBlur}
                        error={formik.touched.telefone_escritorio && Boolean(formik.errors.telefone_escritorio)}
                        helperText={formik.touched.telefone_escritorio && formik.errors.telefone_escritorio}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Phone size={20} />
                                </InputAdornment>
                            ),
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        id="password"
                        name="password"
                        label="Senha para o acesso"
                        type="password"
                        value={formik.values.password}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.password && Boolean(formik.errors.password)}
                        helperText={formik.touched.password && formik.errors.password}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Lock size={20} />
                                </InputAdornment>
                            ),
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        id="confirmPassword"
                        name="confirmPassword"
                        label="Confirme a Senha"
                        type="password"
                        value={formik.values.confirmPassword}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.confirmPassword && Boolean(formik.errors.confirmPassword)}
                        helperText={formik.touched.confirmPassword && formik.errors.confirmPassword}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Lock size={20} />
                                </InputAdornment>
                            ),
                        }}
                    />
                </Grid>
            </Grid>
        </Box>
    );
};

export default PersonalInfoStep;